import React from 'react';
import '../myutils';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader'
import ToggleStar from '@material-ui/icons/Star';
import { translate } from 'react-admin';

const styles = {
    card: { borderLeft: 'solid 4px #31708f', flex: '1', marginRight: '1em' },
    icon: { float: 'right', width: 47, height: 47, padding: 16, color: '#31708f' },
};

export default translate(({ value, translate }) => (
    <Card style={styles.card}>
        <ToggleStar style={styles.icon} />
        <CardHeader title={translate('trans.current_balance')+value} 
        // subtitle={translate('pos.dashboard.total_units')} 
        />
    </Card>
));
